import React from 'react';

import DatepickerBottomActionPanel from '../datepicker-bottom-action-panel/datepicker-bottom-action-panel';
import DatepickerMonth from '../datepicker-month/datepicker-month';
import DatepickerTopActionPanel from '../datepicker-top-action-panel/datepicker-top-action-panel';

import './datepicker-content-wrapper.scss';

interface DatepickerContentWrapperProps {
  activeMonths: { year: number; month: number }[];
  firstDayOfWeek: 0 | 1 | 2 | 3 | 4 | 5 | 6 | undefined;
  goToDate: (date: Date) => void;
  setPresetRange: (
    type:
      | 'week'
      | 'month'
      | 'quarter-1'
      | 'quarter-2'
      | 'quarter-3'
      | 'quarter-4'
  ) => void;
  onSubmit: () => void;
  onCancel: () => void;
  disabled: boolean;
}

const DatepickerContentWrapper: React.FC<DatepickerContentWrapperProps> = ({
  activeMonths,
  onSubmit,
  onCancel,
  setPresetRange,
  goToDate,
  firstDayOfWeek,
  disabled,
}) => {
  const getSelectedData = () => {
    const selectedData = {
      startYear: 0,
      startMonth: 0,
      endYear: 0,
      endMonth: 0,
    };
    if (activeMonths[0]) {
      selectedData.startMonth = activeMonths[0].month;
      selectedData.startYear = activeMonths[0].year;
    }
    if (activeMonths[1]) {
      selectedData.endMonth = activeMonths[1].month;
      selectedData.endYear = activeMonths[1].year;
    }

    return selectedData;
  };

  const onSelectYearMonthChange = (year: number, month: number) => {
    goToDate(new Date(year, month, 1));
  };

  return (
    <div className="datepicker-content">
      <div className="datepicker-content__top">
        <DatepickerTopActionPanel
          onStartYearChange={onSelectYearMonthChange}
          onStartMonthChange={onSelectYearMonthChange}
          onEndYearChange={onSelectYearMonthChange}
          onEndMonthChange={onSelectYearMonthChange}
          selectedStartYear={getSelectedData().startYear}
          selectedEndYear={getSelectedData().endYear}
          selectedStartMonth={getSelectedData().startMonth}
          selectedEndMonth={getSelectedData().endMonth}
        />
      </div>
      <div className="datepicker-content__months">
        {activeMonths.map((item) => (
          <DatepickerMonth
            year={item.year}
            month={item.month}
            firstDayOfWeek={firstDayOfWeek}
          />
        ))}
      </div>
      <div className="datepicker-content__bottom">
        <DatepickerBottomActionPanel
          onSubmit={onSubmit}
          onCancel={onCancel}
          onBadgeClick={setPresetRange}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default DatepickerContentWrapper;
